import React, { useState, useEffect, useRef } from 'react';
import { jarallax } from "jarallax";

import { Box } from '@mui/material';
import NoSsr from '@mui/material/NoSsr';
import { useTheme } from '@mui/material/styles';
import { MainCtn } from '../../layouts/Main/MainStyles';
import TopBox from '../../components/main/TopBox';
import Features from '../../components/main/Features';
import Member from '../../components/main/Member';
import Location from '../../components/main/Location';
import Contact from '../../components/main/Contact';
import TimeTable from '../../components/main/TimeTable';
import News from '../../components/main/News';
import ClassInfo from '../../components/main/ClassInfo';
import HelpQs from '../../components/main/HelpQs';

import img_01 from '../../data/mainImg/image_03.jpg';
import img_02 from '../../data/mainImg/image_04.jpg';
import img_03 from '../../data/mainImg/image_08.jpg';
import FloatBtn from '../../components/common/FloatBtn';
import ChatBot from '../../components/chatbot/ChatBot';
import PhotoGrid from '../../components/main/PhotoGrid';
import PhotoAnimation from '../../components/common/photoAnimation/PhotoAnimation';
import EventModal from '../../components/main/EventModal';

type Props = {}

/** 메인페이지 페이지 컴포넌트 */
const MainPage = (props: Props) => {

    const theme = useTheme();
    useEffect(() => {
        const jarallaxInit = async () => {
            const jarallaxElems = document.querySelectorAll('.jarallax');
            if (!jarallaxElems || (jarallaxElems && jarallaxElems.length === 0)) {
            return;
            }

            jarallax(jarallaxElems, { speed: 0.2 });
        };
    
        jarallaxInit();
    });

    const scrollToTop = (id: any) => {
        setTimeout(() => {
            const element: any = document.querySelector(`#${id}`);
            if (!element) {
                return;
            }
        
            window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
        });
    };

    
    // 스크롤 내릴때마다 컴포넌트 단위로 이동하게 하는 함수: useRef로 다시 구현 예정
    const [ targetId, setTargetId ] = useState('mainBox_'); 
    let downCnt = 1;
    // let upCnt = 1;
        // useEffect(() => {
        //     const scrollToDown = (event: WheelEvent) => {
        //         console.log(event.deltaY)

        //         if (event.deltaY >= 100) {
        //             if (downCnt <= 9) {
        //                 downCnt = downCnt+1;
        //                 const element: HTMLElement | null = document.querySelector(`#${targetId}0${downCnt}`);
        //                 if (element) {
        //                     window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
        //                 };
        //             } else {
        //                 downCnt = 9;
        //                 // const element: HTMLElement | null = document.querySelector(`#${targetId}10`);
        //                 // if (element) {
        //                 //     window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
        //                 // };
        //             }
        //             };

        //         if (event.deltaY == -100) {
        //             if (downCnt >= 1) {
        //                 downCnt = downCnt-1;
        //                 const element: HTMLElement | null = document.querySelector(`#${targetId}0${downCnt}`);
        //                 if (element) {
        //                     window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
        //                 }
        //             } else {
        //                 downCnt = 1;
        //                 const element: HTMLElement | null = document.querySelector(`#${targetId}01`);
        //                 if (element) {
        //                     window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
        //                 };
        //             }
        //             };
        //         };
        //         console.log(downCnt)
        //     window.addEventListener('wheel', scrollToDown);
        // }, [downCnt]);

    // const styles = (bgImage: any) => ({
    //     position: 'absolute',
    //     objectFit: 'cover',
    //     /* support for plugin https://github.com/bfred-it/object-fit-images */
    //     fontFamily: 'object-fit: cover;',
    //     top: 0,
    //     left: 0,
    //     width: '100%',
    //     height: '100%',
    //     zIndex: -1,
    //     backgroundRepeat: 'no-repeat',
    //     backgroundSize: 'cover',
    //     backgroundPosition: 'center center',
    //     backgroundImage: `url(${bgImage})`,
    //     filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
    //     });


    return (
        <>
        <MainCtn>
            <Box
                id="mainBox_01"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '15em',
                    height: '85vh'
                }}
            >
                <TopBox />
                <Box sx={{ marginTop: 4 }}>
                    <NoSsr>
                        <Box
                            component={'svg'}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            width={{ xs: 30, sm: 40 }}
                            height={{ xs: 30, sm: 40 }}
                            onClick={() => scrollToTop('mainBox_02')}
                            sx={{ cursor: 'pointer' }}
                            >
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </Box>
                    </NoSsr>
                </Box>
            </Box>

            <Box
                className={'jarallax'}
                data-jarallax
                data-speed="0.2"
                position={'relative'}
                display={'flex'}
                alignItems={'center'}
                id="mainBox_02"
                sx={{
                    minHeight: '100vh',
                    '@media (max-width: 1300px)': {
                        minHeight: '50vh',
                    }
                }}
            >
                <Box
                    className={'jarallax-img'}
                    sx={{
                        backgroundImage: `url(${img_01})`,
                        backgroundRepeat: 'no-repeat',
                        '@media (max-width: 1300px)': {
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }
                    }}
                    />
            </Box>
            {/* <Box
                className={'jarallax'}
                data-jarallax
                data-speed="0.2"
                position={'relative'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                id="mainBox_03"
            >
                <Box
                className={'jarallax-img'}
                >
                    <img src={img_02} />
                </Box>
            </Box> */}
            <Box
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_04"
                sx={{
                    padding: 5,
                    '@media (max-width: 1300px)': {
                        padding: 0,
                        mt: 5
                    }
                }}
            >
                <Features />
            </Box>
            <Box
                className={'jarallax'}
                data-jarallax
                data-speed="0.2"
                position={'relative'}
                display={'flex'}
                alignItems={'center'}
                id="mainBox_05"
                sx={{
                    minHeight: '100vh',
                    '@media (max-width: 1300px)': {
                        minHeight: '50vh',
                    }
                }}
            >
                <Box
                className={'jarallax-img'}
                sx={{
                    backgroundImage: `url(${img_02})`,
                    '@media (max-width: 1300px)': {
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }
                }}
                />
            </Box>
            {/* <Box
                width={'100v'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_06"
                sx={{
                    padding: 5,
                    '@media (max-width: 1300px)': {
                        padding: 2,
                        mt: 5,
                    }
                }}
            >
                <Member />
            </Box> */}
            {/* <Box
                width={'100v'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_07"
                sx={{
                    padding: 5,
                    '@media (max-width: 1300px)': {
                        padding: 1,
                        mt: 5,
                    }
                }}
            >
                <ClassInfo />
            </Box> */}
            <Box
                width={'100%'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_08"
                sx={{
                    padding: 5,
                    '@media (max-width: 1300px)': {
                        padding: 3,
                        mt: 10,
                    }
                }}
            >
                <News />
            </Box>
            {/* <Box
                className={'jarallax'}
                data-jarallax
                data-speed="0.2"
                position={'relative'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                id="mainBox_05"
            >
                <Box
                className={'jarallax-img'}
                >
                    <img src={img_03} />
                </Box>
            </Box> */}
            {/* <Box
                width={'100%'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                padding={5}
            >
                <HelpQs />
            </Box> */}

            <Box
                width={'100%'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_09"
                sx={{
                    padding: 5,
                    mt: 15,
                    mb: 15,
                    '@media (max-width: 1300px)': {
                        display: 'none',
                        width: '100%',
                        padding: 1,
                        mt: 5,
                    }
                }}
            >
                <PhotoAnimation />
            </Box>
            
            <Box
                className={'jarallax'}
                data-jarallax
                data-speed="0.2"
                position={'relative'}
                display={'flex'}
                alignItems={'center'}
                id="mainBox_02"
                sx={{
                    minHeight: '100vh',
                    '@media (max-width: 1300px)': {
                        minHeight: '50vh',
                    }
                }}
            >
                <Box
                    className={'jarallax-img'}
                    sx={{
                        backgroundImage: `url(${img_03})`,
                        '@media (max-width: 1300px)': {
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }
                    }}
                    />
            </Box>

            <Box
                width={'100%'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_09"
                sx={{
                    padding: 5,
                    '@media (max-width: 1300px)': {
                        width: '100%',
                        padding: 3,
                        mt: 5,
                    }
                }}
            >
                <Contact />
            </Box>
            <Box
                width={'100%'}
                minHeight={'100vh'}
                display={'flex'}
                alignItems={'center'}
                bgcolor={'alternate.main'}
                id="mainBox_10"
                sx={{
                    padding: 10,
                    '@media (max-width: 1300px)': {
                        width: '100%',
                        padding: 1,
                        mt: 5,
                    }
                }}
            >
                <Location />
            </Box>
            {/* <FloatBtn 
                // handleOpen={handleBot}
            /> */}
        </MainCtn>
        {<EventModal />}
        </>
    )
}

export default MainPage